'use strict';
angular.module('appMarketplace')
    .directive('quickAdd', ['$compile', '$templateCache', '$http', 'UrlService', 'NotificationService', 'BasketService',
                            'CommonService', 'OrderService', 'FormattingService',
                            function ($compile, $templateCache, $http, UrlService, NotificationService, BasketService,
                                      CommonService, OrderService, FormattingService) {
        var BASKET_PAGE = '/basket.html';

        return {
            restrict: 'A',
            scope: {
                supplierId: '@',
                documentId: '='
            },
            link: function (scope, element, attrs) {
                function resetItem() {
                    scope.item = {
                        vendorId: scope.supplierId,
                        quantity: 1
                    };
                }

                function resetFilter() {
                    scope.dataSource._filter = null;
                }

                function resetItemSource() {
                    scope.itemSearchDS.data([]);
                }

                function initSource() {
                    scope.dataSource = new kendo.data.DataSource({
                        transport: {
                            read: {
                                url: UrlService.createAbsoluteUrl("/rest/currentAccount/suppliers/visible"),
                                dataType: "json"
                            }
                        }
                    });

                    scope.supplierOptions = {
                        dataTextField: "businessNameUI",
                        dataValueField: "vendorId",
                        valuePrimitive: true,
                        dataSource: scope.dataSource,
                        filter: "contains",
                        optionLabel: "Select a supplier",
                        select: function () {
                            resetItemSource(); //clear autocomplete datasource so popup is empty
                        }
                    };

                    scope.itemSearchDS = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: {
                                url: UrlService.createAbsoluteUrl('/rest/currentAccount/products/itemSearch')
                            },
                            parameterMap: function () {
                                var item = scope.item;
                                var params = {
                                    clin: item.clin
                                };
                                if (item.vendorId) {
                                    params.vendorId = item.vendorId;
                                }
                                return params;
                            }
                        }
                    });

                    scope.doSearch = function () {
                        if (scope.itemSearchDS.view().length) {
                            scope.itemSearch.popup.open();
                        } else {
                            scope.itemSearch.search();
                        }
                    };
                }

                initSource();

                scope.isValidQty = function (qty) {
                    return !!qty && qty > 0 && FormattingService.countDecimals(qty) <= 2;
                };

                scope.isValidItem = function (item) {
                    return !item.expired && scope.isValidQty(item.quantity) && item.quantity >= item.minQuantity;
                };

                var wndw;

                element.on('click', function clickHandler() {
                    if (wndw && wndw.element.length) {
                        return;
                    }
                    resetItem();
                    resetFilter();
                    resetItemSource();

                    $http.get(UrlService.createAbsoluteUrl('/js/main/directives/templates/basket/quick-add-template.html?ver=44f4a2dd2b2bea995d62fbeee8d5f18f'), {cache: $templateCache})
                        .then(function successCallback(response) {
                            var templateElement = angular.element(response.data);
                            var windowElement = $compile(templateElement.filter(".quick-add-template").html())(scope);
                            var position = {
                                top: element.offset().top,
                                left: element.offset().left
                            };
                            scope.itemSearchTemplate = kendo.template(templateElement.filter('#itemSearchTemplate').html());
                            var formErrorTemplate = kendo.template(templateElement.filter("#formErrorTemplate").html());
                            var validator = windowElement.kendoValidator({
                                errorTemplate: formErrorTemplate,
                                messages: {
                                    required: "Field is required",
                                    selectSupplier: "Supplier is not selected",
                                    invalidQty: "Quantity is invalid"
                                },
                                rules: {
                                    selectSupplier: function (input) {
                                        if (input.is("[name=supplier]")) {
                                            return scope.item.vendorId;
                                        }
                                        return true;
                                    }
                                }
                            }).data("kendoValidator");

                            scope.itemSearchOptions = {
                                filtering: function (e) {
                                    var filterValue = e.filter.value;
                                    if (!filterValue || filterValue.length < 2) {
                                        e.preventDefault();  // don't fire request with term shorter than 2 symbols
                                    }
                                },
                                select: function (e) {
                                    var selectedSuggestedItem = e.dataItem;
                                    scope.item.catalogueId = selectedSuggestedItem.catalogueId;
                                    scope.item.vendorId = selectedSuggestedItem.vendorId;
                                    scope.item.quantity = selectedSuggestedItem.quantity;
                                    scope.item.minQuantity = selectedSuggestedItem.minQuantity;
                                    validator.validate();
                                    scope.$apply();
                                }
                            };

                            wndw = windowElement.kendoWindow({
                                actions: ["close"],
                                title: "Quick add",
                                width: 350,
                                maxHeight: 280,
                                visible: false,
                                resizable: false,
                                deactivate: function () {
                                    this.destroy();
                                }
                            }).data("kendoWindow").openInPosition(position);
                            scope.addItem = function () {
                                if (!scope.isValidItem(scope.item) || !validator.validate()) {
                                    return;
                                }
                                if (scope.item.catalogueId) {
                                    scope.item.id = scope.item.clin + ":" + scope.item.catalogueId;
                                }
                                CommonService.showProgressPanel(windowElement, false);
                                if (scope.documentId) {
                                    OrderService.addItemToOrder(scope.item, scope.documentId,
                                        function successCallback(basketActionResult) {
                                            CommonService.hideProgressPanel(windowElement);
                                            NotificationService.showSuccessMessage(basketActionResult.msg);
                                        }, function errorCallback(responseError) {
                                            CommonService.hideProgressPanel(windowElement);
                                            NotificationService.showValidationErrors(responseError);
                                        });
                                } else {
                                    BasketService.addItemToBasket(scope.item,
                                        function basketAddSuccessCallback(result) {
                                            CommonService.hideProgressPanel(windowElement);
                                            scope.$emit('updateBasketEvent', result.basket);
                                            NotificationService.showSuccessMessage('Successfully added to basket');
                                            wndw.close();
                                        }, function errorCallback(responseError) {
                                            CommonService.hideProgressPanel(windowElement);
                                            var validationErrors = responseError.validationErrors;
                                            if (validationErrors && Object.keys(validationErrors).length) {
                                                CommonService.displayValidationErrors(validationErrors, formErrorTemplate, windowElement);
                                            } else {
                                                NotificationService.showErrorMessage(responseError.message);
                                            }
                                        },
                                        {returnBasket: UrlService.checkUrlContains(BASKET_PAGE)});
                                }
                            };
                        }, NotificationService.showValidationErrors);
                });
            }
        };
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/directives/basket/quick-add-directive.js
// module id = 192
// module chunks = 37